import { FiChevronRight } from "react-icons/fi";
import { SectionHeading } from "~/components/SectionHeading";
import { Text } from "~/components/Text";

type GroupChat = {
  node: {
    id: string;
    name: string;
    description?: string | null;
    imageUrl?: string | null;
    memberCount: number;
  };
};

type GroupChatsListProps = {
  chats: GroupChat[];
  onSelect: () => void;
};

export function GroupChatsList({ chats, onSelect }: GroupChatsListProps) {
  if (chats.length === 0) return null;

  return (
    <div className="flex flex-col gap-2.5">
      <SectionHeading as="h3" size="sm" className="!text-[18px] !leading-tight">
        Group chats
      </SectionHeading>
      <ul className="flex flex-col gap-1.5">
        {chats.map(({ node: chat }) => {
          const memberCount = chat.memberCount;
          return (
            <li key={chat.id}>
              <button
                type="button"
                onClick={onSelect}
                className="group flex w-full items-center gap-2.5 rounded-lg p-1.5 text-left"
              >
                <div
                  className="h-13 w-13 flex-shrink-0 overflow-hidden rounded-md bg-butter-cream bg-cover bg-center"
                  style={
                    chat.imageUrl
                      ? { backgroundImage: `url(${chat.imageUrl})` }
                      : undefined
                  }
                  aria-hidden
                />
                <div className="min-w-0 flex-1">
                  <Text
                    as="p"
                    variant="secondary"
                    size="md"
                    weight="bold"
                    className="truncate"
                  >
                    {chat.name}
                  </Text>
                  {chat.description && (
                    <Text
                      as="p"
                      variant="secondary"
                      size="xs"
                      className="line-clamp-1"
                    >
                      {chat.description}
                    </Text>
                  )}
                  {memberCount > 0 && (
                    <Text as="p" variant="secondary" size="xs">
                      {memberCount === 1
                        ? "1 member"
                        : `${memberCount.toLocaleString()} members`}
                    </Text>
                  )}
                </div>
                <FiChevronRight
                  size={14}
                  className="flex-shrink-0 text-butter-green transition-transform group-hover:translate-x-0.5"
                  aria-hidden
                />
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
